import { h, Component } from "preact";

class Loading extends Component {
  render() {
    return <div>Loading...</div>;
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/Loading.js